import { createRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { IncidentStatus } from "@/gql/graphql";
import { appLayoutRoute } from "@/routes/layout-routes";
import { fetchQuery } from "@/lib/GraphQLCodegen/fetcher";
import { proDriversLayout } from "@/app/ProDrivers/Common/Routes/proDriverRoutes";
import { incidentRecordQuery } from "@/app/Incidents/GraphQL/incidentRecordQuery";
import { IncidentRegisterScreen } from "@/app/Incidents/Screens/IncidentRegisterScreen";
import { IncidentRecordScreen } from "@/app/Incidents/Screens/IncidentRecordScreen";
import { IncidentDetailsScreen } from "@/app/Incidents/Screens/IncidentDetailsScreen";
import { IncidentActivityScreen } from "@/app/Incidents/Screens/IncidentActivityScreen";

const incidentRegisterSearchParams = z.object({
  incidentSearch: z.string().optional(),
  incidentPage: z.number().int().min(1).optional().catch(undefined),
  incidentStatus: z.array(z.enum(IncidentStatus)).optional().catch(undefined),
  filterSupplierId: z.string().optional(),
});

export type IncidentRegisterSearchParams = z.infer<
  typeof incidentRegisterSearchParams
>;

export const incidentRegisterRoute = createRoute({
  getParentRoute: () => proDriversLayout,
  path: "/incidents",
  component: IncidentRegisterScreen,
  validateSearch: zodValidator(incidentRegisterSearchParams),
  head: () => ({
    meta: [
      {
        title: "Incidents - Imoova Admin",
      },
    ],
  }),
});

export const incidentRecordRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/pro-drivers/incidents/$incidentId",
  component: IncidentRecordScreen,
  loader: ({ params }) => {
    return fetchQuery(
      incidentRecordQuery,
      { id: params.incidentId },
      params.orgId,
    );
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: `${loaderData?.incident.reference ?? "Incident"} - Imoova Admin`,
      },
    ],
  }),
});

export const incidentDetailsRoute = createRoute({
  getParentRoute: () => incidentRecordRoute,
  path: "/",
  component: IncidentDetailsScreen,
});

export const incidentActivityRoute = createRoute({
  getParentRoute: () => incidentRecordRoute,
  path: "/activity",
  component: IncidentActivityScreen,
});
